import { useState, useEffect } from 'react';
import { Logo, FormRow, Alert } from './components';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useAppContext } from './context/appContext';
import MainLayout from '../../layouts/main-layout';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const initialState = {
  name: '',
  email: '',
  password: '',
  gender: '',
  isMember: true,
};

const Register = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState(initialState);
  const { user, isLoading, showAlert, displayAlert, setupUser } =
    useAppContext();

  const toggleMember = () => {
    setValues({ ...values, isMember: !values.isMember });
  };

  const handleChange = (e: any) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    const { name, email, password, isMember, gender } = values;
    if (!email || !password || (!isMember && !name)) {
      displayAlert();
      return;
    }
    const currentUser = { name, email, password, gender };
    if (isMember) {
      setupUser({
        currentUser,
        endPoint: 'login',
        alertText: 'Login Successful! Redirecting...',
      });
    } else {
      setupUser({
        currentUser,
        endPoint: 'register',
        alertText: 'User Created! Redirecting...',
      });
    }
  };

  useEffect(() => {
    if (user) {
      setTimeout(() => {
        navigate('/e-commerce/product-list');
      }, 3000);
    }
  }, [user, navigate]);

  return (
    <MainLayout>
      <Box
        sx={{
          bgcolor: 'background.paper',
          pt: 12,
          pb: 6,
        }}
      >
        <Container maxWidth="lg">
        <form className='form' onSubmit={onSubmit}>
          <Logo />
          <h3>{values.isMember ? 'Login' : 'Register'}</h3>
          {showAlert && <Alert />}
          <FormRow
            type='email'
            name='email'
            value={values.email}
            handleChange={handleChange}
            testId='email' labelText={undefined}/>
          <FormRow
            type='password'
            name='password'
            value={values.password}
            handleChange={handleChange}
            testId='password' labelText={undefined} />
          
          {!values.isMember && (
            <FormRow
              type='text'
              name='name'
              value={values.name}
              handleChange={handleChange}
              testId='name' labelText={undefined}/>
          )}
          {!values.isMember && (
          <div className='form-row'>
            <label htmlFor='gender' className='form-label'>
              Gender
            </label>
            <div className="radio">
              <label>
                <input
                  name="gender"
                  type="radio"
                  value="Male"
                  checked={values.gender === "Male"}
                  onChange={handleChange}
                  data-testid='male'
                />
                &nbsp;&nbsp;Male
              </label>
            </div>
            <div className="radio">
              <label>
                <input
                  name="gender"
                  type="radio"
                  value="Female"
                  checked={values.gender === "Female"}
                  onChange={handleChange}
                  data-testid='female'
                />
                &nbsp;&nbsp;Female
              </label>
            </div>
            <div className="radio">
              <label>
                <input
                  name="gender"
                  type="radio"
                  value="Other"
                  checked={values.gender === "Other"}
                  onChange={handleChange}
                  data-testid='other'
                />
                &nbsp;&nbsp;Other
              </label>
            </div>
          </div>
          )}
          <div className="d-grid gap-2">
            <Button type='submit' data-testid='submit' disabled={isLoading}>
              submit
            </Button>
          </div>
          <p>
            <br /><br />
            {values.isMember ? 'Not a member yet?  ' : 'Already a member?  '}
            <Button type='button' onClick={toggleMember} className='member-btn' data-testId='loginLink'>
              {values.isMember ? 'Register' : 'Login'}
            </Button>
          </p>
        </form>

        </Container>
      </Box>
    </MainLayout>
  );
};
export default Register;
